module.exports = __webpack_public_path__ + "assets/f4b743984b8ad3e16a2b38e1f30bc69f.jpg";